import { useState, useEffect } from "react";
import { ExternalLink, Copy, Unlink, Check } from "lucide-react";
import FloatingBubble from "../FloatingBubble";
import "./Bubbles.css";

function normalizeUrl(u) {
  if (!u) return "";
  const trimmed = u.trim();
  if (!trimmed) return "";
  if (/^(https?:|mailto:|tel:|#|\/)/i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export default function LinkBubble({ anchorEl, iframeEl, onClose, onChange }) {
  const [url, setUrl] = useState(anchorEl.getAttribute("href") || "");
  const [text, setText] = useState(anchorEl.textContent || "");
  const [newTab, setNewTab] = useState(anchorEl.getAttribute("target") === "_blank");

  useEffect(() => {
    setUrl(anchorEl.getAttribute("href") || "");
    setText(anchorEl.textContent || "");
    setNewTab(anchorEl.getAttribute("target") === "_blank");
  }, [anchorEl]);

  const apply = () => {
    const href = normalizeUrl(url);
    anchorEl.setAttribute("href", href || "#");
    if (text !== anchorEl.textContent) anchorEl.textContent = text;
    if (newTab) {
      anchorEl.setAttribute("target", "_blank");
      anchorEl.setAttribute("rel", "noopener noreferrer");
    } else {
      anchorEl.removeAttribute("target");
      anchorEl.removeAttribute("rel");
    }
    onChange();
    onClose();
  };

  const unlink = () => {
    const parent = anchorEl.parentNode;
    while (anchorEl.firstChild) parent.insertBefore(anchorEl.firstChild, anchorEl);
    parent.removeChild(anchorEl);
    onChange();
    onClose();
  };

  const copy = () => {
    if (navigator.clipboard) navigator.clipboard.writeText(anchorEl.getAttribute("href") || "");
  };

  const open = () => {
    const href = anchorEl.getAttribute("href");
    if (href) window.open(href, "_blank", "noopener");
  };

  return (
    <FloatingBubble anchorEl={anchorEl} iframeEl={iframeEl} label="Link" onClose={onClose}>
      <div className="bubble-field">
        <label>URL</label>
        <input
          type="text"
          value={url}
          autoFocus
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://example.com"
        />
      </div>
      <div className="bubble-field">
        <label>Text</label>
        <input type="text" value={text} onChange={(e) => setText(e.target.value)} />
      </div>
      <label className="bubble-toggle">
        <input type="checkbox" checked={newTab} onChange={(e) => setNewTab(e.target.checked)} />
        Open in new tab
      </label>
      <div className="bubble-actions">
        <button type="button" className="bubble-btn primary" onClick={apply}>
          <Check size={12} /> Apply
        </button>
        <button type="button" className="bubble-btn icon-only" title="Copy URL" onClick={copy}>
          <Copy size={13} />
        </button>
        <button type="button" className="bubble-btn icon-only" title="Open" onClick={open}>
          <ExternalLink size={13} />
        </button>
        <button type="button" className="bubble-btn danger icon-only" title="Unlink" onClick={unlink}>
          <Unlink size={13} />
        </button>
      </div>
    </FloatingBubble>
  );
}
